import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useWichList } from './useWichList';

const useWichListCount = () => {
  const { user } = useAuth();
  const { count, countLoading, refreshMeta } = useWichList();
  const initialFetchRequestedRef = useRef(false);

  // Reset initial fetch tracking when the user changes
  useEffect(() => {
    initialFetchRequestedRef.current = false;
  }, [user?.id]);

  // Treat the very first load with a null count as "loading" so we don't flash 0
  const isInitialLoading = !!user && count === null && !countLoading;

  useEffect(() => {
    if (!user) return;
    if (!isInitialLoading) return;
    if (initialFetchRequestedRef.current) return;

    initialFetchRequestedRef.current = true;
    refreshMeta();
  }, [user, isInitialLoading, refreshMeta]);

  if (!user) {
    return {
      count: null,
      loading: false,
      error: null,
      // No-op refresh when logged out
      refresh: () => {}
    };
  }

  return {
    count,
    // Surface loading as true during both the initial inferred load and any explicit meta refreshes
    loading: countLoading || isInitialLoading,
    error: null,
    refresh: refreshMeta
  };
};

export default useWichListCount;

